import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { MerchSizes } from './constants';
import { buildMerchStoreConfig } from '../storeAliasHelper';
import { data_STAGING } from './STAGING';

export const EvolveTshirtBlackProduct = {
  title: "'Evolve' Black T-shirt",
  description: '100% organic Supima cotton. Made carbon neutral.',
  imgSrc: 'web_v2/all-products/merch/new/evolve-tee-black.png/w_1920',
  shopifyProductName: 'Evolve T-shirt',
  availableSizes: [
    MerchSizes.S,
    MerchSizes.M,
    MerchSizes.L,
    MerchSizes.XL,
    MerchSizes.XXL,
  ],
};

export const EvolveTshirtBlackShopifyMap: Record<
  ShopifyStore,
  {
    price: number;
    sizes: Record<MerchSizes, { variantId: string; checkoutUrl: string }>;
  }
> =
  process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
    ? buildMerchStoreConfig<MerchSizes>({
        [ShopifyStore.AE]: {
          price: 95,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/44691327647986',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691327647986:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/44691327713522',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691327713522:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/44691327779058',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691327779058:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/44691327844594',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691327844594:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/44691327910130',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691327910130:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.US]: {
          price: 25,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40200402174048',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200402174048:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40200402239584',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200402239584:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40200402305120',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200402305120:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40200402370656',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200402370656:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40200402436192',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200402436192:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.ROW]: {
          price: 25,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40718623735868',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718623735868:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40718623834172',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718623834172:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40718623899708',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718623899708:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40718623965244',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718623965244:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40718624030780',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718624030780:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.IN]: {
          price: 1599,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40288002768966',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40288002768966:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40288002834502',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40288002834502:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40288002801734',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40288002801734:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40288002867270',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40288002867270:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40303544696902',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40303544696902:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.EU]: {
          price: 23,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/49202720211262',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202720211262:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/49202720276798',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202720276798:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/49202720342334',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202720342334:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/49202720407870',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202720407870:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/49202720473406',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202720473406:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.GB]: {
          price: 20,
        },
        [ShopifyStore.AU]: {
          price: 38,
        },
        [ShopifyStore.CA]: {
          price: 35,
        },
        [ShopifyStore.MX]: {
          price: 534,
        },
        [ShopifyStore.SA]: {
          price: 109,
        },
        [ShopifyStore.ZA]: {
          price: 499,
        },
        [ShopifyStore.JP]: {
          price: 3800,
        },
      })
    : data_STAGING;
